import { render, staticRenderFns } from "./EditServiceSideBarTabsPricing.vue?vue&type=template&id=e9a72384&scoped=true&"
import script from "./EditServiceSideBarTabsPricing.vue?vue&type=script&lang=js&"
export * from "./EditServiceSideBarTabsPricing.vue?vue&type=script&lang=js&"
import style0 from "./EditServiceSideBarTabsPricing.vue?vue&type=style&index=0&id=e9a72384&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a72384",
  null
  
)

export default component.exports